import { DetailedHTMLProps, InputHTMLAttributes, useState } from 'react';
import { HiEye, HiEyeOff } from 'react-icons/hi';

type Props = {
    withoutPasswordReveal?: boolean;
} & Omit<DetailedHTMLProps<InputHTMLAttributes<HTMLInputElement>, HTMLInputElement>, 'type'>;

export default function PasswordInput({ withoutPasswordReveal = false, ...rest }: Props) {
    const [showPassword, setShowPassword] = useState(false);

    if (withoutPasswordReveal) {
        <input {...rest} type="password" />;
    }

    return (
        <div className="relative">
            <input
                {...rest}
                className={`${rest.className || ''} pr-8`}
                type={showPassword ? 'text' : 'password'}></input>
            <i
                className="text-primary absolute right-2 top-3 cursor-pointer text-xl"
                onClick={() => setShowPassword(!showPassword)}>
                {showPassword ? <HiEyeOff /> : <HiEye />}
            </i>
        </div>
    );
}
